/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryItems = sqliteTable('inventory_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  item_type: text('item_type'),
  item_name: text('item_name'),
  sku: text('sku'),
  external_id: text('external_id'),
  category: text('category'),
  tags: text('tags'),
  local_name: text('local_name'),
  description: text('description'),
  remarks: text('remarks'),
  status: text('status'),
  image_url: text('image_url'),
  selling_price: real('selling_price'),
  minimum_selling_price: real('minimum_selling_price'),
  cost_price: real('cost_price'),
  tax_inclusive: integer('tax_inclusive'),
  open_pricing: integer('open_pricing'),
  purchasing_unit: text('purchasing_unit'),
  inventory_unit: text('inventory_unit'),
  pack_size_quantity: integer('pack_size_quantity'),
  track_stock: integer('track_stock'),
  initial_stock_quantity: integer('initial_stock_quantity'),
  low_stock_limit: integer('low_stock_limit'),
  minimum_order_quantity: integer('minimum_order_quantity'),
  inactive: integer('inactive'),
  dispense_via_pharmacy: integer('dispense_via_pharmacy'),
  manufacturing_barcode: text('manufacturing_barcode'),
  accounting_code: text('accounting_code'),
  external_reference_code: text('external_reference_code'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
